/**
 *
 * ResultDrillDown
 *
 */

import "./index.less"

import {
  Button,
  Checkbox,
  Empty,
  Popover,
  Select,
  Tooltip,
  TreeSelect,
} from "antd"
import {
  DISABLE,
  RESULT_BY_DIMENSION,
  RESULT_BY_DIVISION,
  RESULT_BY_TEAM,
} from "../../../../../utils/constants"
import {
  KEY_CHECKBOX_EXCLUDE,
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
  isModeInModuleBySlug,
  setItem,
} from "../../../../../utils/storage"
import React, { Fragment } from "react"

import ContainerDrillDown from "components/ContainerDrillDown"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import { QuestionCircleFilled } from "@ant-design/icons"
import { compose } from "redux"
import { connect } from "react-redux"
import empty_meditions from "../../../../../images/emptyDivisions.svg"
import { generateTree } from "../../../../../utils/utils"
import { get } from "lodash"

const { Option } = Select
const { TreeNode } = TreeSelect

/* eslint-disable react/prefer-stateless-function */
export class ResultDrillDown extends React.Component {
  state = {
    selectedFilter: undefined,
    selectedType: "Engagement",
    checkboxExclude: LOCAL_CHECKBOX_EXCLUDE() == "true",
  }

  changeExcludeCheckbox = async (e, filters) => {
    setItem(KEY_CHECKBOX_EXCLUDE, e.target.checked)
    this.setState({ checkboxExclude: e.target.checked })
    filters.onChange(this.state.selectedFilter, e.target.checked)
  }

  setNameMetricsTotalLabel = () => {
    const { measure_general } = this.props
    let surveyType = get(measure_general, "id_survey_type", null)
    let hasLabel = get(measure_general, "metric_total_label", null)
    let response = "Resultado total"
    if (surveyType === 1 && hasLabel !== null) {
      response = get(measure_general, "metric_total_label", null)
    }

    return response
  }

  handleReturn = () => {
    const { subLink, history } = this.props
    return history.push({
      pathname: `${subLink.link}`,
    })
  }

  render() {
    const {
      data,
      isLoading,
      metric,
      filters,
      subLink,
      title,
      style,
      bubbles,
      textLeyend,
      textEmpty,
      isEngagement,
      isEngagementOnly,
      excludeSub,
      forceEmpty,
      measure_general,
      isLeadership,
      isDimensions,
      isTooltip,
    } = this.props

    const { selectedFilter, selectedType, checkboxExclude } = this.state

    if (filters.drilldown) {
      filters.filters = generateTree(
        filters.drilldown[0],
        filters.drilldown[1],
        filters.filters,
        "childs",
        false
      )
      if (
        filters.filters.length > 0 &&
        selectedType == "Engagement" &&
        isEngagement
      ) {
        filters.filters = filters.filters[0].childs
      }
    }

    let isRedirect = false
    if (!metric) {
      isRedirect = isModeInModuleBySlug(RESULT_BY_DIMENSION)
    } else {
      if (isLeadership) {
        isRedirect = isModeInModuleBySlug(RESULT_BY_TEAM)
      } else {
        isRedirect = isModeInModuleBySlug(RESULT_BY_DIVISION)
      }
    }
    return (
      <div className="boxShadow ResultDrillDown " style={{ ...style }}>
        <h4>{title}</h4>
        <div className="ContainerDrillDown">
          {!isLoading && (forceEmpty || (data.length === 0 && textEmpty)) ? (
            <Empty
              style={{ color: "#828282" }}
              image={empty_meditions}
              description={textEmpty}
              className="ReportsHome-empty-fix"
            />
          ) : (
            <Fragment>
              <div className="ResultDrillDown-header">
                {isRedirect !== DISABLE && (
                  <div className="ResultDrillDown-header-btn-link">
                    <span>
                      <Link to={subLink.link}>{subLink.title}</Link>
                    </span>
                  </div>
                )}
                {filters.show &&
                  excludeSub &&
                  LOCAL_ISOLATED_METRICS() == "true" && (
                    <div
                      style={{
                        marginLeft: "auto",
                        paddingRight: 10,
                        height: 30,
                        paddingTop: 5,
                      }}>
                      <Checkbox
                        checked={checkboxExclude}
                        onChange={(e) =>
                          this.changeExcludeCheckbox(e, filters)
                        }>
                        Excluir subdivisiones
                      </Checkbox>
                      <Popover
                        placement="top"
                        content={
                          <div style={{ maxWidth: 245, textAlign: "center" }}>
                            Activa el checkbox para visualizar los
                            <br />
                            resultados únicamente de las
                            <br />
                            divisiones superiores, <b>excluyendo</b> los
                            <br />
                            resultados de sus subdivisiones.
                          </div>
                        }>
                        <QuestionCircleFilled
                          style={{
                            color: "#D8D8D8",
                            verticalAlign: "baseline",
                            fontSize: "14px",
                            marginLeft: 8,
                          }}
                        />
                      </Popover>
                    </div>
                  )}
                <div className="">
                  {!filters.show ? null : filters.drilldown ? (
                    <TreeSelect
                      style={{ width: 240 }}
                      placeholder={filters.placeHolder}
                      showSearch
                      allowClear
                      value={selectedFilter}
                      treeNodeFilterProp="title"
                      onChange={(s, c, extra) => {
                        this.setState({ selectedFilter: s }, () => {
                          filters.onChange(
                            extra.triggerNode && extra.triggerNode.props
                              ? extra.triggerNode.props.idSelected
                              : undefined,
                            checkboxExclude
                          )
                        })
                      }}>
                      {filters.filters.map((e) => {
                        return (
                          <TreeNode
                            idSelected={filters.id ? e[filters.id] : e.id}
                            value={filters.id ? e[filters.id] : e.id}
                            title={filters.name ? e[filters.name] : e.name}
                            key={filters.id ? e[filters.id] : e.id}>
                            {e.childs &&
                              e.childs.map((child) => {
                                return (
                                  <TreeNode
                                    value={
                                      filters.id ? child[filters.id] : child.id
                                    }
                                    key={
                                      filters.id ? child[filters.id] : child.id
                                    }
                                    idSelected={
                                      filters.id ? child[filters.id] : child.id
                                    }
                                    title={
                                      <Tooltip
                                        title={
                                          filters.name
                                            ? child[filters.name]
                                            : child.name
                                        }>
                                        {filters.name
                                          ? child[filters.name]
                                          : child.name}
                                      </Tooltip>
                                    }
                                  />
                                )
                              })}
                          </TreeNode>
                        )
                      })}
                    </TreeSelect>
                  ) : (
                    <Select
                      showSearch
                      allowClear
                      placeholder={filters.placeHolder}
                      value={selectedFilter}
                      onChange={(s, c) => {
                        this.setState({ selectedFilter: s }, () => {
                          filters.onChange(c ? c.props.idSelected : undefined)
                        })
                      }}
                      style={{ width: 200 }}>
                      {filters.filters.map((f, i) => (
                        <Option
                          idSelected={filters.id ? f[filters.id] : f.id}
                          key={i}
                          value={filters.name ? f[filters.name] : f.name}>
                          <Tooltip
                            placement="leftTop"
                            title={filters.name ? f[filters.name] : f.name}>
                            {filters.name ? f[filters.name] : f.name}
                          </Tooltip>
                        </Option>
                      ))}
                    </Select>
                  )}

                  {isEngagement && !isEngagementOnly && (
                    <Select
                      placeholder="Seleccionar"
                      defaultValue="Engagement"
                      onChange={(s) => {
                        this.setState(
                          { selectedType: s, selectedFilter: undefined },
                          () =>
                            this.props.onChangeEngagement(s, checkboxExclude)
                        )
                      }}
                      style={{ width: 200, marginLeft: 8 }}>
                      {["Engagement", this.setNameMetricsTotalLabel()].map(
                        (f, i) => (
                          <Option key={i} value={f}>
                            {f}
                          </Option>
                        )
                      )}
                    </Select>
                  )}
                </div>
              </div>
              <ContainerDrillDown
                textLeyend={textLeyend}
                bubbles={bubbles}
                bubblesNumber
                isLoading={isLoading}
                isTooltip={isTooltip}
                metric={metric}
                isDimensions={isDimensions}
                data={data}
                measure_general={measure_general}
              />
            </Fragment>
          )}
        </div>
      </div>
    )
  }
}

ResultDrillDown.propTypes = {
  isLeadership: PropTypes.bool,
  isTooltip: PropTypes.bool,
  isDimensions: PropTypes.bool,
}

export default ResultDrillDown
